import { useQuery } from '@tanstack/react-query';
import { useBusinessAccountContext } from '@/hooks/useBusinessAccountContext';
import { razorpayApi } from '@/lib/api/services/razorpay';

export function useRazorpayConnection(businessAccountId?: string | null) {
    const { selectedAccountId } = useBusinessAccountContext();
    // Allow callers (e.g. the inbox MessageArea) to pass an explicit BA id; falls
    // back to the context-selected account. Same query key either way, so every
    // consumer shares ONE cached /razorpay/:id/connection result per account.
    const accountId = businessAccountId ?? selectedAccountId;

    return useQuery({
        queryKey: ['razorpay-connection', accountId],
        queryFn: async () => {
            if (!accountId) return false;
            try {
                const response = await razorpayApi.checkConnection(accountId);
                return response.connected;
            } catch (error) {
                return false;
            }
        },
        enabled: !!accountId,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
